/**
 * @generated SignedSource<<ff22c1967454463c68e200cbffb7cc51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SortEnumType = "ASC" | "DESC" | "%future added value";
export type AllStudentsFilterInput = {
  anyDiagnosticRetakeAssigned?: boolean | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  lastDiagnosticCompletedFrom?: any | null | undefined;
  lastDiagnosticCompletedTo?: any | null | undefined;
  onlyWithOutstandingDiagnostic?: boolean | null | undefined;
  onlyWithResetDiagnostic?: boolean | null | undefined;
  siteIds?: ReadonlyArray<string> | null | undefined;
  studentEmailContains?: string | null | undefined;
  studentEmails?: ReadonlyArray<string> | null | undefined;
  studentNameContains?: string | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
};
export type UserSortInput = {
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  email?: SortEnumType | null | undefined;
  externalSync?: ExternalSyncSortInput | null | undefined;
  externalSyncId?: SortEnumType | null | undefined;
  firstName?: SortEnumType | null | undefined;
  fullName?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  isMetabaseAccessEnabled?: SortEnumType | null | undefined;
  isMetabaseEmailEnabled?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastName?: SortEnumType | null | undefined;
  lastNameFirst?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  owner?: UserSortInput | null | undefined;
  publicUserId?: SortEnumType | null | undefined;
};
export type ExternalSyncSortInput = {
  id?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastUpdatedOn?: SortEnumType | null | undefined;
  source?: SortEnumType | null | undefined;
};
export type StudentsAllStudentsWithoutTotalQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  filter: AllStudentsFilterInput;
  first?: number | null | undefined;
  last?: number | null | undefined;
  order?: ReadonlyArray<UserSortInput> | null | undefined;
  skip?: boolean | null | undefined;
};
export type StudentsAllStudentsWithoutTotalQuery$data = {
  readonly allStudents?: {
    readonly nodes: ReadonlyArray<{
      readonly classes: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly diagnostics: ReadonlyArray<{
        readonly id: string;
        readonly isInferred: boolean;
        readonly retakeAssigned: boolean;
        readonly sessionCompletedOn: any;
        readonly sessionStartedOn: any;
      } | null | undefined> | null | undefined;
      readonly firstName: string | null | undefined;
      readonly gradeLevels: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly roles: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly sites: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  } | null | undefined;
};
export type StudentsAllStudentsWithoutTotalQuery = {
  response: StudentsAllStudentsWithoutTotalQuery$data;
  variables: StudentsAllStudentsWithoutTotalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v9 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
          },
          {
            "kind": "Variable",
            "name": "order",
            "variableName": "order"
          }
        ],
        "concreteType": "StudentConnection",
        "kind": "LinkedField",
        "name": "allStudents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Student",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StudentSkillDiagnosticNode",
                "kind": "LinkedField",
                "name": "diagnostics",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isInferred",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "retakeAssigned",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sessionCompletedOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sessionStartedOn",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClassNode",
                "kind": "LinkedField",
                "name": "classes",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GradeLevelNode",
                "kind": "LinkedField",
                "name": "gradeLevels",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SiteNode",
                "kind": "LinkedField",
                "name": "sites",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleNode",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StudentsAllStudentsWithoutTotalQuery",
    "selections": (v9/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "StudentsAllStudentsWithoutTotalQuery",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "8a95071092f06c5deb504d5a40a4f38c",
    "id": null,
    "metadata": {},
    "name": "StudentsAllStudentsWithoutTotalQuery",
    "operationKind": "query",
    "text": "query StudentsAllStudentsWithoutTotalQuery(\n  $filter: AllStudentsFilterInput!\n  $first: Int\n  $after: String\n  $last: Int\n  $skip: Boolean = false\n  $before: String\n  $order: [UserSortInput!]\n) {\n  allStudents(filter: $filter, first: $first, after: $after, last: $last, before: $before, order: $order) @skip(if: $skip) {\n    nodes {\n      diagnostics {\n        id\n        isInferred\n        retakeAssigned\n        sessionCompletedOn\n        sessionStartedOn\n      }\n      id\n      firstName\n      lastName\n      classes {\n        id\n        name\n      }\n      gradeLevels {\n        id\n        name\n      }\n      sites {\n        id\n        name\n      }\n      roles {\n        id\n        name\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d15d35744664c9812ac5bd1a09194b85";

export default node;
